<template>
  <g transform="translate(191 2599)">
    <g transform="translate(-189 -2603.486)">
      <path
        d="M4.366,9.354H16.182V6.2a.7.7,0,0,0-.712-.712H.712A.7.7,0,0,0,0,6.2V16.472a.7.7,0,0,0,.712.712H3.654V10.065A.7.7,0,0,1,4.366,9.354Z"
        transform="translate(0 1)"
        fill="#be8ae3"
      />
      <path
        d="M92.27,88.033H77.512a.7.7,0,0,0-.712.712V99.019a.7.7,0,0,0,.712.712h6.359l3.179,3.488a.762.762,0,0,0,.522.237.523.523,0,0,0,.19-.024.727.727,0,0,0,.522-.522L89,99.731H92.27a.7.7,0,0,0,.712-.712V88.745A.7.7,0,0,0,92.27,88.033Z"
        transform="translate(-73.312 -77.798)"
        fill="#aa79ce"
      />
    </g>
    <rect
      width="24"
      height="24"
      transform="translate(-191 -2599)"
      fill="none"
    />
  </g>
</template>
